import React, { useState } from "react";
import * as S from "./styles.ts";
import Input from "../Inputs/Input/index.tsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationMedicoSchema } from "../../schemas/validationSchema.ts";
import { Typography } from "@mui/material";
import { InputMaskEnum } from "../../enums/InputMask.ts";
import { Medico } from "../../models/Medico.ts";
import { Endereco } from "../../models/Endereco.ts";
import medicoService from "../../services/medicoService.ts";
import { Response } from "../../types/Api.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/index.tsx";
import { MedicoFormData } from "./type.ts";
import EnderecoComponent from "../Endereco/index.tsx";

type CadastroMedicoProps = {
  onAdd?: (data: any) => void;
};

const CadastroMedico: React.FC<CadastroMedicoProps> = ({ onAdd }) => {
  const navigate = useNavigate();
  const { showFeedback } = useFeedback();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationMedicoSchema),
  });

  const createMedico = (data: any): Medico => {
    const endereco: Endereco = new Endereco(
      data.endereco.rua,
      data.endereco.bairro,
      data.endereco.cep,
      data.endereco.numero,
      data.endereco.cidade,
      data.endereco.uf
    );
    return new Medico(
      0,
      data.nome,
      data.email,
      data.telefone,
      data.crm,
      endereco
    );
  };

  const onSubmit = async (data: any) => {
    const medico: Medico = createMedico(data);
    setIsLoading(true);
    try {
      const response: Response<Medico> = await medicoService.create(medico);
      showFeedback(response.message, "success");
      if (onAdd) onAdd(response);
      else {
        navigate("/medico/listagem");
      }
    } catch (error) {
      showFeedback(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.Form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
      <S.InputGroup>
        <Input
          label="Nome*"
          variant="outlined"
          register={register("nome")}
          error={errors.nome}
          helperText={errors.nome?.message}
        />
        <Input
          label="CRM*"
          variant="outlined"
          register={register("crm")}
          error={errors.crm}
          helperText={errors.crm?.message}
        />
        <Input
          label="E-mail"
          variant="outlined"
          register={register("email")}
          error={errors.email}
          helperText={errors.email?.message}
        />
        <Input
          label="Telefone*"
          register={register("telefone")}
          error={errors.telefone}
          helperText={errors.telefone?.message}
          format={InputMaskEnum.BrazilPhone}
        />
      </S.InputGroup>

      <Typography variant="h6" gutterBottom sx={{ color: "var(--ink)" }}>
        Endereço
      </Typography>
      <EnderecoComponent<MedicoFormData>
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        control={control}
      />
      <S.SubmitButton variant="contained" color="primary" type="submit">
        {isLoading ? <Loading color="white" /> : "Cadastrar"}
      </S.SubmitButton>
    </S.Form>
  );
};

export default CadastroMedico;
